import posthog from 'posthog-js';

let initialized = false;

/** The analytics client, or `null` while no key is configured. */
export function getPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY;

  if (!key) {
    return null;
  }

  if (!initialized) {
    posthog.init(key, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
      defaults: '2026-05-30',
      autocapture: true,
      capture_exceptions: true,
      capture_pageview: 'history_change',
      disable_session_recording: false,
    });
    // Every event says which deployment sent it, so staging and the clinics'
    // own servers can share a project without their numbers mixing.
    const environment = import.meta.env.VITE_POSTHOG_APP_ENVIRONMENT;

    if (environment) {
      posthog.register({ app_environment: environment });
    }

    initialized = true;
  }

  return posthog;
}
